import { render, staticRenderFns } from "./teacherCheckDetails.vue?vue&type=template&id=1ab53141&"
import script from "./teacherCheckDetails.vue?vue&type=script&lang=js&"
export * from "./teacherCheckDetails.vue?vue&type=script&lang=js&"
import style0 from "./teacherCheckDetails.vue?vue&type=style&index=0&id=1ab53141&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports